module.exports = __webpack_public_path__ + "img/Template_Linkedin_Soluta.9625a4bf.png";